export const formatReports = (data, user) => {
    if (!data?.length) return [];
    return data.map((item) => {
        return {
            user: {
                user_id: user?.user_id,
                first_name: user?.first_name,
                last_name: user?.last_name,
            },
            type: {
                created_at: null,
                description: "Visite",
                meeting_type_id: "1",
            },
            report: item,
            client_id: item.client_id,
            meeting_id: item.meeting_id,
            is_visited: true,
            start_date: item.created_at,
            end_data: item.created_at,
            meeting_type_id: "1",
        };
    });
};

export const toggleReport = (reportData, setSelectedReport) => {
    if (reportData) {
        setSelectedReport(reportData); // Set the selected report data
    } else {
        setSelectedReport(null); // Clear the selected report data
    }
};
